module.exports = __webpack_public_path__ + "img/jicheng (4).014c4622.png";